






import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import { to_do_state } from "@/types/todo/todo";
import { updateToDoAsync } from "@/todos";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "FinishToDo",
    props: {
        todoId: Number
    },
    async created() {
        this.registerHandlers({ ok: this.updateToDo, cancel: this.onCancel });
    },
    methods: {
        async updateToDo(): Promise<boolean> {
            const response = await updateToDoAsync(this.todoId, {
                state: to_do_state.finished
            });
            if (response.success) {
                this.goToTasks();
                return true;
            }
            return false;
        },
        goToTasks(): void {
            this.$router.push({ name: "Tasks" });
        },
        onCancel(): Promise<boolean> {
            this.$router.push({ name: "Tasks" });
            return Promise.resolve(true);
        }
    }
});
